define('views/components/reseller_product_modal/reseller_products',['require','views/base/collection_view','views/components/reseller_product_modal/reseller_product_list','text!templates/components/reseller_product_modal/reseller_products.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/reseller_product_modal/reseller_product_list');

    var temp = require("text!templates/components/reseller_product_modal/reseller_products.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container reseller-product-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

